export default __webpack_public_path__ + "static/media/Alert_Icon.99bcb1c3.svg";